var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobepos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 36.5c0-.7-.3-1.3-.8-1.8-.4-.4-1-.7-1.7-.7s-1.3.3-1.8.7c-.4.5-.7 1.1-.7 1.8s.3 1.3.7 1.7c.5.5 1.1.8 1.8.8s1.3-.3 1.7-.8c.5-.4.8-1 .8-1.7Zm6.4-5V9.7a1 1 0 0 0-.3-.7 1 1 0 0 0-.7-.3H4a1 1 0 0 0-.7.3 1 1 0 0 0-.2.7v21.8c0 .3 0 .5.2.7.2.2.5.3.7.3h16c.2 0 .4 0 .6-.3.2-.2.3-.4.3-.7ZM15 5.2c0-.3-.1-.5-.4-.5h-5c-.3 0-.5.2-.5.5 0 .4.2.5.5.5h5c.3 0 .5-.1.5-.5Zm9-.5v31.8c0 1-.4 2-1.2 2.8-.8.8-1.7 1.2-2.8 1.2H4c-1 0-2-.4-2.7-1.2A3.8 3.8 0 0 1 0 36.5V4.7A4 4 0 0 1 4 .8h16c1 0 2 .3 2.7 1.1a4 4 0 0 1 1.2 2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileapp);
export default __webpack_public_path__ + "static/media/icon-mobileapp.d93f24d6bd59f2e9bf6258956819a0aa.svg";
export { ForwardRef as ReactComponent };